import useAppToast from 'hooks/useAppToast';

const useNotify = () => {
  const { toastSuccess, toastError } = useAppToast();

  const notifySuccess = (message: React.ReactNode) => toastSuccess(message);

  const notifyError = (message: React.ReactNode) => toastError(message);

  return { notifySuccess, notifyError };
};

export default useNotify;
